<section id="pageCover" class="row">
    <img src="../../../assets/images/contactCover.png" alt="" class="pageCover">
    <!--<div class="row pageTitle">Projects</div>-->
    <div class="row pageBreadcrumbs">
        <!--<ol class="breadcrumb">
            <li><a href="index.html">home</a></li>
            <li class="active">Projects</li>
        </ol>-->
    </div>
</section>

<section id="latestPosts" class="row">
    <div class="container">
        <div class="row sectionTitles">
            <h2 class="sectionTitle">
                {{'OurVision' | translate}}
            </h2>
            <div class="sectionSubTitle">{{'vision' | translate}}</div>
        </div>
        <div class="row">

            <img class="img-en"src="../../../../assets/images/ouervision.png" width="100%" />
            <img class="img-ar" src="../../../../assets/images/ouervisionAR.png" alt="" width="100%">


        </div>
    </div>
</section>